import * as React from "react";
import DataComponent from "../common/DataComponent";
import { connect } from "react-redux";
import * as types from "../../constants/actionTypes";
import FavoritedLabel from "./FavoritedLabel";
import { Link } from 'react-router-dom';
import MiniSpinner from "../common/MiniSpinner";
import * as Tools from "../../helpers/Tools";
import { logUI } from "../../api/andyliticsApi";
import DirectScheduleButton from "../appointments/DirectScheduleButton";

class MyCareTeamProviders extends DataComponent {

    constructor(props) {
        super(props);
        this.state = {
        };
        this.providerCard = this.providerCard.bind(this);
        this.navToProvider = this.navToProvider.bind(this);

    }

    componentDidMount() {
        if (super.componentDidMount) { super.componentDidMount(); }
        logUI("MBHWeb.UI.MyCareTeamProviders.ComponentDidMount", new Date(), Tools.getURLPath());
    }

    shouldLoadData() {
        const { IsLoggedIn, ProvidersList, fetchingProviders } = this.props;
        return false; // IsLoggedIn && !ProvidersList && !fetchingProviders;
    }

    loadData() {
        const { loadCareTeamProviders } = this.props;
        loadCareTeamProviders();
    }

    navToProvider(npi) {
        const { history } = this.props;
        history.push("/providers/" + npi);
    }

    providerCard(provider, index) {
        let location = null;
        let more = 0;
        if (provider.Locations.length > 0) {
            location = provider.Locations[0];
            more = provider.Locations.length - 1;
        }

        //debugger;
        return (
            <div className="col-12 col-lg-6" key={index}>
                <div className="card docs">
                    <div className="card-body">
                        <div className="row">
                            <div className="col-12 finger" onClick={() => { this.navToProvider(provider.NPI) }}>
                                <div className="docs__img-container">
                                    <img alt={Tools.trimComma(provider.DisplayName) + " photo"} src={provider.Photo || "/images/profile-pic.png"} />
                                </div>
                                <div className="docs__info-container">
                                    <div className="col-12">

                                        <div className="docs__info-container--name">
                                            {Tools.trimComma(provider.DisplayName)}
                                        </div>
                                        <div className="docs__info-container--specialty">
                                            {provider.Specialties.map((specialty) => {
                                                return specialty.Specialty;
                                            }).join(",")}
                                        </div>
                                        <div className="docs__info-container--details">
                                            <div className="details-icon-prepend">
                                                <div className="icon-col"><span className="icon-address" /></div>
                                                <div className="details-col">
                                                    <div>{location && location.LocationCity + ", " + location.LocationState + "   " + (more > 0 ? "(+" + more + " more)" : "")}</div> {/* Doc's main city and state + however many other locations they work at. Link to the doctor's details page. */}
                                                </div>
                                            </div>
                                            <div className="details-icon-prepend">
                                                <div className="icon-col"><span className="icon-phone" /></div>
                                                <div className="details-col">
                                                    <div>{location && location.LocationPhone}</div>
                                                </div>
                                            </div>
                                        </div>
                                        <FavoritedLabel NPI={provider.NPI} />
                                        {
                                            window.serverData.data.enableDirectScheduling &&
                                            this.props.directNpiList.includes(provider.NPI) &&
                                            <DirectScheduleButton npi={provider.NPI} />
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        );
    }


    render() {
        const { ProvidersList, hasMyChart } = this.props;
        if (!hasMyChart) return <React.Fragment />;
        return (
            <React.Fragment>
                <div className="row">
                    <div className="col-12">
                        <div className="page-heading section-heading">My Care Team</div>
                    </div>
                </div>

                <div className="row row-card-eq">
                    You can temporarily access your care team by clicking over to your&nbsp; <Link to="/planofcare">Plan Of Care</Link>.
                </div>
                    {/*
                    (!ProvidersList) ?
                        <MiniSpinner /> 
                        : ProvidersList.length === 0 ? <div className="row"><div className="col-12 no-care-team">No care team doctors are available.</div></div> :
                        <React.Fragment>
                            {
                                ProvidersList.map((providerRow, index) => {
                                    return (
                                        <div className="row row-card-eq" key={index}>
                                            <React.Fragment>
                                                {
                                                    providerRow.map((provider, index2) => {
                                                        return this.providerCard(provider, index2);
                                                    })
                                                }
                                            </React.Fragment>
                                        </div>);
                                })
                            }
                        </React.Fragment>
                */}
            </React.Fragment>
    );}

};



const mapStateToProps = (state, ownProps) => {
    return {
        UserName: state.domain.un,
        Token: state.domain.t, 
        IsLoggedIn: state.domain.li, 
        ProvidersList: state.healthSource.careTeamProvidersCards, 
        fetchingProviders: state.healthSource.fetchingCareTeamProviders, 
        history: state.session.history, 
        hasMyChart: !state.common.epicEHRDown && state.domain.hm,
        directNpiList: state.directScheduling.providerNpiList
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        loadCareTeamProviders: () => {
            //debugger;
            dispatch({
                type: types.GET_CARETEAM_PROVIDERS_START
            });
        },

    };
};

export default connect(mapStateToProps, mapDispatchToProps)(MyCareTeamProviders);